import { PopupActionTypes, PopupActions } from "./PopupActions";

export enum PopupStatus {
  IN_ACTIVE = 'IN_ACTIVE',
  HIDDEN = 'HIDDEN',
  PROMOTION_VISIT = 'PROMOTION_VISIT',
  PROMOTION_LOGGED_IN = 'PROMOTION_LOGGED_IN',
  APP_INSTALL = 'APP_INSTALL',
  GLIFE_EXTERNAL_LINK_DISCLAIMER  = 'GLIFE_EXTERNAL_LINK_DISCLAIMER',
}
export interface PopupState {
    popupStatus: PopupStatus | null;
    customContext: { [key: string]: any };
}

const initialState: PopupState = { popupStatus: null, customContext: {} };

export function popupReducer(state: PopupState = initialState, action: PopupActions) {
  switch (action.type) {
    case PopupActionTypes.UPDATE_STATUS:
        return {...state, popupStatus: action.status, customContext: {}}
    case PopupActionTypes.SET_CUSTOM_CONTEXT:
        return {...state, customContext: {...state.customContext, ...action.updatedContext}};
    default:
      return state;
  }
}

